import { MESSAGES } from '@guuru/chat-common';
import {
  appendLocalMessage,
  getCurrentChat,
  setCurrentChatSession,
  ChatAPI,
} from '@guuru/chat-web';
import events from '@guuru/events-web';
import { delay as sleep } from '@guuru/helpers-common';
import createChat from '../commands/createChat';
import handleChatStatusChange from '../commands/handleChatStatusChange';
import hotTransferChat from '../commands/hotTransferChat';

const thankForFillingForm = 'bot:::thankForFillingForm';

const addBotThanksMessage = async () => {
  const customerName = ChatAPI.storeRetrieveName();
  const thanksMessage = await sleep(ChatAPI.getBotDelayMessageDelay()).then(
    () => {
      const message = ChatAPI.messages.createBotMessage(
        Date.now(),
        thankForFillingForm,
        MESSAGES.message,
        { customerName },
        true,
        false,
      );
      ChatAPI.pushPendingMessages(message);
      return message;
    },
  );
  return thanksMessage;
};

export default {
  validate() {
    return true;
  },
  async render(partnerId) {
    events.connectingWithExpert();

    const thanksMessage = await addBotThanksMessage();
    appendLocalMessage(thanksMessage);

    // check if we have already a chat
    // if no then just create a new one
    // if yes then we do an hotTransfer and we need to send the messages
    // that are not yet on the database :(
    const { chatId: currentChatId } = getCurrentChat();

    if (!currentChatId) {
      const { chatId, updatedChat } = await createChat(partnerId);

      if (!chatId) return { goToNextStep: false };

      setCurrentChatSession({
        chatId,
        messages: updatedChat?.messages?.edges,
      });
      handleChatStatusChange({ chatId, ...updatedChat });
      return { goToNextStep: false };
    }

    await hotTransferChat(partnerId, currentChatId);

    return { goToNextStep: false };
  },
};
